module.exports = __webpack_public_path__ + "media/images/nav_icons/settings-5ca34f9db6a22b31a2e200584e7ab4f3.png";